import React from 'react';
import { motion } from 'framer-motion';

const brands = [
  {
    name: 'Brand 1',
    logo: '/brand1.svg',
    link: 'https://brand1.com',
  },
  {
    name: 'Brand 2',
    logo: '/brand2.svg',
    link: 'https://brand2.com',
  },
  {
    name: 'Brand 3',
    logo: '/brand3.svg',
    link: 'https://brand3.com',
  },
  // Add more brands as needed
];

export const WorkedWith: React.FC = () => {
  return (
    <section className="py-16 bg-gray-50">
      <div className="container mx-auto px-4">
        <h2 className="text-3xl font-bold text-center mb-12">Trusted by Industry Leaders</h2>
        <div className="relative overflow-hidden">
          <motion.div
            className="flex space-x-12"
            animate={{
              x: [0, -1000],
            }}
            transition={{
              x: {
                repeat: Infinity,
                repeatType: "loop",
                duration: 20,
                ease: "linear",
              },
            }}
          >
            {brands.map((brand, index) => (
              <a
                key={index}
                href={brand.link}
                target="_blank"
                rel="noopener noreferrer"
                className="flex-shrink-0 w-32 h-32 grayscale hover:grayscale-0 transition-all duration-300"
                aria-label={`Visit ${brand.name}'s website`}
              >
                <img
                  src={brand.logo}
                  alt={`${brand.name} logo`}
                  className="w-full h-full object-contain"
                />
              </a>
            ))}
          </motion.div>
        </div>
      </div>
    </section>
  );
}; 